import React from 'react';
import { filterSchema } from '../utility/filterSchema';
import CalculatedSection from './CalculatedSection';
import KeyMetrics from '../../KeyMetrics';

export default function Calculations({
  calculationsSchema,
  beforeData,
  afterData,
  keyMetricsSchema,
  keyMetricsData,
  onReportClick = () => {},
}) {
  const { schema } = calculationsSchema;

  // filter out each section base on conditions
  const filteredSchema = schema.map((section) => {
    if (section.schema) {
      const filteredSection = filterSchema(section.schema, {
        ...beforeData,
        ...afterData,
      });
      return {
        ...section,
        schema: filteredSection,
      };
    }
    if (section.leftSchema && section.rightSchema) {
      const filteredLeftSection = filterSchema(section.leftSchema.schema, {
        ...beforeData,
        ...afterData,
      });
      const filteredRightSection = filterSchema(section.rightSchema.schema, {
        ...beforeData,
        ...afterData,
      });
      return {
        ...section,
        leftSchema: { ...section.leftSchema, schema: filteredLeftSection },
        rightSchema: { ...section.rightSchema, schema: filteredRightSection },
      };
    }
  });

  const orderFirst = filteredSchema.find(
    (section) =>
      section.layoutClasses && section.layoutClasses.includes('order-first')
  );

  return (
    <div className="mb-4 col-span-4">
      <div className="flex flex-col">
        {filteredSchema.map((section, index) => {
          if (index === 0 && !orderFirst) {
            return (
              <div
                key={`${section.sectionLabel} + ${index}`}
                className="grid grid-cols-4"
              >
                {keyMetricsSchema && keyMetricsSchema.length > 0 && (
                  <KeyMetrics schema={keyMetricsSchema} data={keyMetricsData} />
                )}
                <CalculatedSection
                  onReportClick={onReportClick}
                  sectionSchema={section}
                  data={
                    section.onlyBeforeData || !afterData
                      ? beforeData
                      : { ...beforeData, ...afterData }
                  }
                  //here we need conditional formatting for the first section but not if the key metrics are in a row
                  first={index === 0}
                  //   first={
                  //     keyMetricsSchema && keyMetricsSchema.length > 0
                  //       ? keyMetricsSchema[0].layout !== 'row'
                  //       : null
                  //   }
                />
              </div>
            );
          } else if (index === filteredSchema.length - 1 && orderFirst) {
            return (
              <div
                key={`${section.sectionLabel} + ${index}`}
                className="grid grid-cols-4 mb-1 order-first"
              >
                {keyMetricsSchema && keyMetricsSchema.length > 0 && (
                  <div className="order-first col-span-4 sm:col-span-1">
                    <KeyMetrics
                      schema={keyMetricsSchema}
                      data={keyMetricsData}
                    />
                  </div>
                )}
                <CalculatedSection
                  onReportClick={onReportClick}
                  sectionSchema={section}
                  data={
                    section.onlyBeforeData || !afterData
                      ? beforeData
                      : { ...beforeData, ...afterData }
                  }
                  first
                />
              </div>
            );
          }
          return (
            <CalculatedSection
              onReportClick={onReportClick}
              key={`${section.sectionLabel} + ${index}`}
              sectionSchema={section}
              data={
                section.onlyBeforeData || !afterData
                  ? beforeData
                  : { ...beforeData, ...afterData }
              }
            />
          );
        })}
      </div>
    </div>
  );
}
